import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getVessels } from "../../data/vessels";
import { getTerminals } from "../../data/terminals";
import { getLabels } from "../../data/labels";
import { getContainerTypes } from "../../data/containertype";
import { getVoyages } from "../../data/voyage";

export const useInitialPlannerData = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getVessels());
    dispatch(getTerminals());
    dispatch(getContainerTypes());
    dispatch(getLabels());
    dispatch(getVoyages());
  }, [dispatch]);
};
